import Vue from 'vue'

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	let arr = value.split(" ")
	let capitalized_array = []
	arr.forEach((word) => {
		let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
		capitalized_array.push(capitalized)
	})
	return capitalized_array.join(" ");
});

Vue.filter('birthdate', function (value) {
	if (!value) return ''
	let date = new Date(value)
	let year = date.getFullYear()
	let day = date.getDate()
	let month = date.getMonth() + 1
	if (day < 10) {
		day = '0' + day;
	} 
	if (month < 10) {
	month = '0' + month;
	} 
	return day+'/'+month+'/'+year
});

Vue.filter('numberFormat', function (value) {
	if (!value) return ''
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
});
Vue.filter('month', function(val, showYear = true) {
	val = String(val)
  
	const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
	if(!showYear) {
	  return regx.exec(val)[1];
	}else {
	  return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
	}
  
  })
  